module.exports = {
  'en': {
    'HRES92UC1': {
      '0': '[HRES92U] Approve Cancel Training Request',
      '10': '[HRES92U] Approve Cancel Training Request',
      '20': 'No.',
      '30': 'Emp. ID.',
      '40': 'Name',
      '50': 'Reqest Date',
      '55': 'No.',
      '60': 'Year',
      '70': 'Class',
      '80': 'Training Course',
      '90': 'Type of training',
      '100': 'Status',
      '110': 'Approved By',
      '120': 'Appr.Date',
      '130': 'Remark',
      '140': 'Next Approve',
      '150': 'Detail of Cancel Training Request',
      '160': 'Approve By Next Step'
    },
    'HRES92UC2': {
      '0': 'Details of Cancel Training Request',
      '10': 'Details of Cancel Training Request',
      '20': 'Employee Name',
      '30': 'Requested Date',
      '40': 'Year',
      '50': 'Class',
      '60': 'Training Course',
      '70': 'Trainning Date',
      '80': 'Qtytrain',
      '90': 'Hour',
      '100': 'Institute',
      '110': 'Location',
      '120': 'Instructor',
      '130': 'Remark',
      '140': 'Update By'
    },
    'HRES92UC3': {
      '10': 'Details of Approve',
      '20': 'No.of  selected',
      '30': 'Record',
      '40': 'For Employee',
      '50': 'Seq. No',
      '60': 'Approved By',
      '70': 'Approved Date',
      '80': 'Current Status',
      '90': 'Status Approve',
      '99': 'Request for Record Cancel Trainning',
      '100': 'Approved',
      '110': 'Refused',
      '120': 'Remark'
    }
  },
  'th': {
    'HRES92UC1': {
      '0': '[HRES92U] อนุมัติคำร้องยกเลิกการฝึกอบรม',
      '10': '[HRES92U] อนุมัติคำร้องยกเลิกการฝึกอบรม',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ขอ',
      '55': 'ลำดับที่',
      '60': 'ปี',
      '70': 'รุ่นที่',
      '80': 'หลักสูตรอบรม',
      '90': 'ประเภท',
      '100': 'สถานะ',
      '110': 'ผู้อนุมัติ',
      '120': 'วันที่อนุมัติ',
      '130': 'หมายเหตุการอนุมัติ',
      '140': 'ผู้อนุมัติลำดับถัดไป',
      '150': 'คำร้องเรื่อง ขอยกเลิกการฝึกอบรม',
      '160': 'อนุมัติโดยข้ามขั้นตอน'
    },
    'HRES92UC2': {
      '0': 'รายละเอียดคำร้องขอยกเลิกการฝึกอบรม',
      '10': 'รายละเอียดคำร้องขอยกเลิกการฝึกอบรม',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่ยื่นขอ',
      '40': 'ปี',
      '50': 'รุ่นที่',
      '60': 'หลักสูตรอบรม',
      '70': 'วันที่อบรม',
      '80': 'จำนวน ชม.อบรม',
      '90': 'ชม.',
      '100': 'สถาบัน',
      '110': 'สถานที่',
      '120': 'วิทยากร',
      '130': 'หมายเหตุการขอยกเลิก',
      '140': 'ผู้บันทึก'
    },
    'HRES92UC3': {
      '10': 'รายละเอียดการอนุมัติ',
      '20': 'รายการที่เลือกทั้งหมด',
      '30': 'รายการ',
      '40': 'สำหรับพนักงาน',
      '50': 'ลำดับที่อนุมัติ',
      '60': 'อนุมัติโดย',
      '70': 'วันที่อนุมัติ',
      '80': 'สถานะปัจจุบัน',
      '90': 'สถานะการอนุมัติ',
      '99': 'คำร้องขอยกเลิกการฝึกอบรม',
      '100': 'อนุมัติ',
      '110': 'ไม่อนุมัติ',
      '120': 'หมายเหตุ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres92u.js